const imageStage = document.querySelector('#imageStage');
const designCanvas = document.querySelector('#designCanvas');
const productVisual = document.querySelector('#productVisual');
const productArt = document.querySelector('#productArt');
const productImage = document.querySelector('#productImage');
const productPixelZone = document.querySelector('#productPixelZone');
const productPixelCanvas = document.querySelector('#productPixelZone canvas');
const blurName = document.querySelector('#blurName');
const signupAnchor = document.querySelector('#signupAnchor');
const errorStack = document.querySelector('#errorStack');
const waitlistSection = imageStage.closest('.fembiotic-waitlist');
const thankYouModal = document.querySelector('#waitlistThankYou');
const thankYouCloseButtons = thankYouModal.querySelectorAll('[data-thank-you-close]');

const designSize = {
  width: 1920,
  height: 1080,
};

const productSize = {
  width: 741,
  height: 992,
};

const productPixelCrop = {
  x: 110,
  y: 215,
  width: 455,
  height: 655,
};

// Cinco clics de revelación; el quinto conserva el último nivel de pixelado.
const pixelLevels = [18, 15.4, 12.8, 10.2, 7.6, 5];
let pixelLevelIndex = 0;
let currentPixelSize = pixelLevels[pixelLevelIndex];
let animationFrame = null;
let errorMode = false;
let errorCount = 0;
let released = false;
let releaseTimer = null;
let lastFocusedElement = null;

function isMobileLayout() {
  return window.matchMedia('(max-width: 720px)').matches;
}

function positionComposition() {
  if (isMobileLayout()) {
    designCanvas.style.setProperty('--canvas-scale', '1');
    productVisual.style.right = '0px';
    const visualWidth = productVisual.getBoundingClientRect().width;
    productArt.style.transform = `scale(${visualWidth / productSize.width})`;
    return;
  }

  const stageRect = imageStage.getBoundingClientRect();
  const scale = Math.min(
    stageRect.width / designSize.width,
    stageRect.height / designSize.height,
  );
  designCanvas.style.setProperty('--canvas-scale', String(scale));
  // Si la altura limita la escala, el artboard queda centrado y deja márgenes
  // laterales. Desplazamos únicamente el producto para que su borde derecho
  // coincida con el borde real del viewport.
  const extraLocalWidth = Math.max(0, stageRect.width / scale - designSize.width);
  productVisual.style.right = `${-(extraLocalWidth / 2)}px`;
  productArt.style.transform = 'scale(1)';
}

function drawProductPixelation(pixelSize) {
  if (pixelSize === 0) {
    productPixelZone.classList.add('is-hidden');
    return;
  }

  if (!productImage.complete || productImage.naturalWidth === 0) return;

  productPixelZone.classList.remove('is-hidden');

  const sampleWidth = Math.max(2, Math.ceil(productPixelCrop.width / pixelSize));
  const sampleHeight = Math.max(2, Math.ceil(productPixelCrop.height / pixelSize));
  productPixelCanvas.width = sampleWidth;
  productPixelCanvas.height = sampleHeight;

  const context = productPixelCanvas.getContext('2d');
  context.clearRect(0, 0, sampleWidth, sampleHeight);
  context.imageSmoothingEnabled = false;
  context.drawImage(
    productImage,
    productPixelCrop.x,
    productPixelCrop.y,
    productPixelCrop.width,
    productPixelCrop.height,
    0,
    0,
    sampleWidth,
    sampleHeight,
  );
}

function getNameBlur(pixelSize) {
  const first = pixelLevels[0];
  const last = pixelLevels[pixelLevels.length - 1];
  const progress = Math.max(0, Math.min(1, (first - pixelSize) / (first - last)));
  const minimumBlur = 3.8;
  return minimumBlur + (7.6 - minimumBlur) * (1 - progress);
}

function renderComposition(pixelSize = currentPixelSize) {
  positionComposition();
  drawProductPixelation(pixelSize);
  blurName.style.filter = `blur(${pixelSize === 0 ? 0 : getNameBlur(pixelSize)}px)`;
}

function animatePixelation(targetPixelSize) {
  if (animationFrame) cancelAnimationFrame(animationFrame);

  const startPixelSize = currentPixelSize;
  const startTime = performance.now();
  const duration = 650;

  const tick = (now) => {
    const progress = Math.min((now - startTime) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    currentPixelSize = startPixelSize + (targetPixelSize - startPixelSize) * eased;
    renderComposition(currentPixelSize);

    if (progress < 1) {
      animationFrame = requestAnimationFrame(tick);
    } else {
      currentPixelSize = targetPixelSize;
      renderComposition(currentPixelSize);
      animationFrame = null;
    }
  };

  animationFrame = requestAnimationFrame(tick);
}

function revealNextStep() {
  if (pixelLevelIndex >= pixelLevels.length - 1) return;
  pixelLevelIndex += 1;
  const targetPixelSize = pixelLevels[pixelLevelIndex];

  // En el quinto clic el error aparece antes de iniciar el último avance del pixelado.
  if (pixelLevelIndex === pixelLevels.length - 1) {
    errorMode = true;
    spawnErrorWindow();
  }

  animatePixelation(targetPixelSize);
}

function createErrorWindow() {
  const windowElement = document.createElement('article');
  windowElement.className = 'error-window';
  windowElement.setAttribute('role', 'status');
  windowElement.innerHTML = `
    <div class="error-title-bar">
      <span class="error-title">ERROR</span>
      <span class="error-controls" aria-hidden="true">
        <span class="error-control">−</span>
        <span class="error-control">□</span>
        <span class="error-control error-control-close">×</span>
      </span>
    </div>
    <div class="error-window-body">
      <div class="error-message-row">
        <span class="error-icon" aria-hidden="true"></span>
        <p class="error-copy">Vuelve el 10 de agosto</p>
      </div>
      <button class="fix-button" type="button">Ver más</button>
    </div>
  `;
  return windowElement;
}

function spawnErrorWindow() {
  errorCount += 1;
  const offsets = [
    { x: 0, y: 0, rotate: -1 },
    { x: -12, y: 10, rotate: 1 },
    { x: 12, y: -12, rotate: -2 },
    { x: -15, y: -2, rotate: 2 },
    { x: 8, y: 15, rotate: -1 },
  ];
  const offset = offsets[(errorCount - 1) % offsets.length];
  const windowElement = createErrorWindow();
  windowElement.style.setProperty('--error-x', `${offset.x}px`);
  windowElement.style.setProperty('--error-y', `${offset.y}px`);
  windowElement.style.setProperty('--error-rotate', `${offset.rotate}deg`);
  windowElement.style.zIndex = String(errorCount);
  errorStack.appendChild(windowElement);
}

function handleStageClick(event) {
  if (released) {
    if (event.target.closest('#signupAnchor')) return;
    return;
  }
  if (errorMode) {
    spawnErrorWindow();
    return;
  }
  revealNextStep();
}

function applyReleaseState(animate = true) {
  if (released) return;

  released = true;
  pixelLevelIndex = pixelLevels.length - 1;
  errorMode = false;
  waitlistSection.classList.add('is-released');
  errorStack.replaceChildren();

  if (!animate) {
    currentPixelSize = 0;
    renderComposition(0);
    return;
  }

  // Conserva el nivel actual y lo lleva a cero sin volver a aumentar el blur.
  renderComposition(currentPixelSize);
  window.setTimeout(() => animatePixelation(0), 100);
}

function loadReleaseState() {
  const releaseAt = Date.parse(waitlistSection.dataset.releaseAt || '');
  if (!Number.isFinite(releaseAt)) return;

  const timeUntilRelease = releaseAt - Date.now();
  if (timeUntilRelease <= 0) {
    applyReleaseState(false);
    return;
  }

  releaseTimer = window.setTimeout(() => {
    releaseTimer = null;
    applyReleaseState(true);
  }, timeUntilRelease);
}

function openThankYouModal() {
  lastFocusedElement = document.activeElement;
  thankYouModal.hidden = false;
  thankYouModal.setAttribute('aria-hidden', 'false');
  requestAnimationFrame(() => {
    thankYouModal.classList.add('is-visible');
    thankYouModal.querySelector('.waitlist-thank-you__close').focus();
  });
}

function closeThankYouModal() {
  thankYouModal.classList.remove('is-visible');
  thankYouModal.setAttribute('aria-hidden', 'true');
  window.setTimeout(() => {
    thankYouModal.hidden = true;
    if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
  }, 180);
}

imageStage.addEventListener('click', handleStageClick);
signupAnchor.addEventListener('click', (event) => event.stopPropagation());

thankYouCloseButtons.forEach((button) => {
  button.addEventListener('click', closeThankYouModal);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && !thankYouModal.hidden) closeThankYouModal();
});

// Klaviyo emite este evento cuando el envío principal del formulario fue realizado.
window.addEventListener('klaviyoForms', (event) => {
  const detail = event.detail || {};
  const formId = String(detail.formId || '');
  const configuredFormId = String(waitlistSection.dataset.klaviyoFormId || '');

  if (detail.type === 'submit' && formId === configuredFormId) {
    openThankYouModal();
  }
});

imageStage.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  if (released) return;
  if (errorMode) spawnErrorWindow();
  else if (!event.target.closest('#signupAnchor')) revealNextStep();
});

window.addEventListener('resize', () => renderComposition());

// Se evalúa antes de la primera renderización para que una visita posterior
// a la fecha de lanzamiento nunca muestre el producto pixelado ni por un instante.
loadReleaseState();

function revealProductAfterPixelation() {
  renderComposition();
  productVisual.classList.add('is-ready');
}

productImage.addEventListener('load', revealProductAfterPixelation, { once: true });

if (productImage.complete && productImage.naturalWidth > 0) {
  revealProductAfterPixelation();
} else {
  renderComposition();
}